// form related shared styles
import { cn } from 'src/utils/cn';

export const borderRadius = '0.188rem';

// it looks like chrome doesn't render smaller border widths then 0.1rem
// this would only work, if we'd use an svg as a fake border (similar to our file upload)
export const borderWidth = '0.1rem';

/**
 * This fakes the placeholder style for elements that should look like a placeholder,
 * but are not actually placeholders (no `:placeholder` selector).
 */
export const placeholderLikeClasses = cn(`
  text-foreground-surface-subdued italic
  legacy:text-legacy-brand-light-2
`);

export const formFieldBaseClasses = cn(
  // inline-block instead block needed to display correct baseline for Firefox
  `
    inline-block w-full rounded-xs border border-border-surface-default bg-white
    p-md align-baseline text-foreground-surface-default
    placeholder:text-foreground-surface-subdued placeholder:italic
    placeholder:opacity-100
    legacy:rounded-[0.188rem] legacy:border-legacy-brand legacy:pt-[0.6rem]
    legacy:pr-[2rem] legacy:pb-[0.7rem] legacy:pl-[2rem] legacy:leading-[normal]
    legacy:text-legacy-brand legacy:placeholder:text-legacy-brand-light-2
  `
);

export const formFieldErrorClasses = cn(
  `
    border-border-support-error-subdued bg-background-support-error-minimal
    text-foreground-support-error
    placeholder:text-foreground-support-error
    legacy:border-legacy-error legacy:bg-legacy-error-lighter
    legacy:text-legacy-error legacy:placeholder:text-legacy-error
  `
);

export const formFieldDisabledClasses = cn(`
  disabled:cursor-not-allowed disabled:border-border-surface-disabled
  disabled:bg-background-surface-disabled
  disabled:text-foreground-surface-disabled
  disabled:placeholder:text-foreground-surface-disabled
  legacy:disabled:border-legacy-inactive
  legacy:disabled:bg-legacy-inactive-lighter
  legacy:disabled:text-legacy-inactive
  legacy:disabled:placeholder:text-legacy-inactive
`);
